export default __webpack_public_path__ + "static/probably-had-these-thoughts-while-shopping-d703b7ed86933a41442e19fcc1519d9e.jpg";